"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPinOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M29 10.81a10.44 10.44 0 00-2.84-4.95A10.44 10.44 0 0021.19 3l-.52-.1-7.08 7.1h-5l-2 2 6 6L2.5 28h2.83L14 19.37l6 6 2-2v-5l7.08-7.08zm-9 6.78v5L9.41 12h5l6.88-6.88a9 9 0 015.59 5.59z" })));
}
exports.default = SvgPinOutline;
//# sourceMappingURL=PinOutline.js.map